<template>
    <div>
        <navbar></navbar>
        <div class="container"> 
            <p class="__somep">Case studies of  Talent Placements</p>
            <p class="__absom">Some of our Talent Placements</p>
            <p class="__abproduct1">Our clientele comprises some of the most progressive companies across the globe. We work with businesses spanning different sectors but having the same desire - the need for great tech. We listen to our clients and with distinctive collaboration, transform their big ideas into exceptional products.<br>We work with the best and deliver the best, such that when your product launches, you are guaranteed two things - smiles and satisfaction.</p>
            <p class="__abproduct1">Send us a mail at <a href="mailto:info@findworka.com" class="__sendmess"> info@findworka.com</a> to say hello and can also <router-link to="/build" class="__sendmess">begin a project</router-link> with us.</p>
        </div>    
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="__procards">
                       <router-link to="/talentpillar" class="__procards">
                            <img src="../assets/img/findworka-talents.png" class="__climgpro">
                            <div class="__divpro">
								<p class="__meetdname __namp">How Findworka Powered Pillar’s Fintech Growth with Elite Engineering Talent</p>
								
								<p class="__meetdname"><span class="__namp">Client Name:</span> Pillar (UK Fintech)</p>
								<p class="__meetdname"><span class="__namp">Services:</span> Backend Engineering · Mobile Development · Quality Assurance</p>
								
								<!-- <p class="__soci">{{ project.shortDescription }}</p> -->
								<p class="__a">Learn More &nbsp;<span><i class="fas fa-arrow-right shake"></i></span></p>
							</div>
						</router-link>
					</div>
                </div>

				<div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="__procards">
                       <router-link to="/talentgdl" class="__procards">
                            <img src="../assets/img/findworka-talents.png" class="__climgpro">
                            <div class="__divpro">
								<p class="__meetdname __namp">Findworka’s Precision Hiring for GDL Finance’s Investment App</p>
								
                                <p class="__meetdname"><span class="__namp">Client Name:</span> GDL Finance (Lagos, Nigeria)</p>
								<p class="__meetdname"><span class="__namp">Talent Hired:</span> Node.js Backend Developer, Frontend Developer, ...</p>
								
								<!-- <p class="__soci">{{ project.shortDescription }}</p> -->
								<p class="__a">Learn More &nbsp;<span><i class="fas fa-arrow-right shake"></i></span></p>
							</div>
						</router-link>
					</div>
                </div>

				<div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="__procards">
                       <router-link to="/talentklak" class="__procards">
                            <img src="../assets/img/findworka-talents.png" class="__climgpro">
                            <div class="__divpro">
								<p class="__meetdname __namp">How Findworka Outsourced a Node.js Engineer to Power Klak Technologies’ Financial Toolkit</p>
								<p class="__meetdname"><span class="__namp">Client Name:</span> Klak Technologies</p>
								<p class="__meetdname"><span class="__namp">Talent Hired:</span> Node.js Backend Developer (3-month engagement, ongoing)</p>
								
								
								<!-- <p class="__soci">{{ project.shortDescription }}</p> -->
								<p class="__a">Learn More &nbsp;<span><i class="fas fa-arrow-right shake"></i></span></p>
							</div>
						</router-link>
					</div>
                </div>


				<div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="__procards">
                       <router-link to="/talentriby" class="__procards">
                            <img src="../assets/img/findworka-talents.png" class="__climgpro">
                            <div class="__divpro">
								<p class="__meetdname __namp">How Findworka Assembled a Full Engineering Team to Power Riby's Retailar Product for Nigerian Merchants</p>
								
								<p class="__meetdname"><span class="__namp">Client Name:</span> Riby</p>
								<p class="__meetdname"><span class="__namp">Talent Hired:</span> Node.js Backend Developer, Flutter Mobile Developer...</p>
								
								<!-- <p class="__soci">{{ project.shortDescription }}</p> -->
								<p class="__a">Learn More &nbsp;<span><i class="fas fa-arrow-right shake"></i></span></p>
							</div>
						</router-link>
					</div>
                </div>
            </div>
			
		</div>
        

        <div class="__stbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-5">
                        <p class="__wwd">Start Project</p>
                        <p class="__fbuild">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                        <router-link to="/build" class="btn __startp">Start Project</router-link>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-7"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import navbar from "../components/navbar";

	export default {
        components: { navbar },
		data(){
			return {}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/css/project';
</style>


// WEBPACK FOOTER //
// src/components/Case-Studies-Talent-Placement.vue